module.exports = __webpack_public_path__ + "assets/57f512d90e136f3bdc4307efc36f38cd.png";